import React, { useState, useEffect } from 'react';

const ErrorMessage = ({ errorText }) => {


    return (
        <div className="errro_Show text-center mt-3">
            <p className="text-danger">{errorText}</p>
        </div>
    );
};

export default ErrorMessage;
